import './style/index.js';

import _Button from './button';

export type { ButtonProps } from './button';
export const Button = _Button;
export default Button;

export * from './type';
